export const QteOptions = [
    {
        key: "empty",
        text: "",
        value: ""
    },
    { key: "1", text: "1 boite", value: "1 boite" },
    { key: "2", text: "2 boites", value: "2 boites" },
    { key: "3", text: "3 boites", value: "3 boites" },
    { key: "4", text: "4 boites", value: "4 boites" },
    { key: "5", text: "5 boites", value: "5 boites" },
    { key: "6", text: "6 boites", value: "6 boites" },
    { key: "7", text: "7 boites", value: "7 boites" },
    { key: "8", text: "8 boites", value: "8 boites" },
    { key: "9", text: "9 boites", value: "9 boites" },
    { key: "10 boites", text: "10 boites", value: "10 boites" },
];